import React, { useEffect, useState } from 'react'
import List from '../../../component/campus/student/offCampusStudentList'
import { offCampusStudentList } from '../../../actions/campus';

const CollegeStudentList = (props) => {
    const [page, setPage] = useState(1)
    const [list, setList] = useState(null)
    const [count, setCount] = useState(null)
    const [showLoader, setShowLoader] = useState(false)

    useEffect(() => {
        setShowLoader(true)
        offCampusStudentList(page).then((res) => {
            setShowLoader(false)
            if (res.status) {
                setList(res.result.list)
                setCount(res.result.count)
            }
        })
    }, [page])
    return (
        <React.Fragment>

            {<List
                title={'OFF Campus Student List'}
                student_list={list}
                count={count}
                page={page}
                onPageChange={(newPage) => { setPage(newPage) }}
                showLoader={showLoader}
            />
            }
        </React.Fragment>
    )
}

export default (CollegeStudentList)